const Uid = process.env.VUE_APP_UID;
const Token = process.env.VUE_APP_TOKEN;
const Secret = process.env.VUE_APP_SECRET;
const Host = process.env.VUE_APP_HOST;
const Port = process.env.VUE_APP_PORT;
const PDFUrl = process.env.VUE_APP_PDF_URL;
const WebUrl = process.env.VUE_APP_WEB_URL
const NewsUrl = process.env.VUE_APP_NEWS_URL;
const AgentUrl = process.env.VUE_APP_AGENT_URL;
const ImageUrl = process.env.VUE_APP_IMAGE_URL;
const DiagramUrl = process.env.VUE_APP_DIAGRAM_URL
const PageSize = 10;
const IosApp = 'https://apps.apple.com/app/id879209391';
const AndroidApp = 'https://play.google.com/store/apps/details?id=ca.city365.homapp';

const thisYear = new Date().getFullYear();
const YearOptions = Array.from({length: thisYear-2021}, (_, i) => 2022 + i);
const ProvinceOptionsLess = [
  '福建',
  '江西',
];
const ProvinceOptions = [
  '全国',
  '北京',
  '天津',
  '上海',
  '重庆',
  '黑龙江',
  '吉林',
  '辽宁',
  '山西',
  '山东',
  '江苏',
  '浙江',
  '福建',
  '广东',
  '广西',
  '云南',
  '河北',
  '河南',
  '陕西',
  '甘肃',
  '宁夏',
  '湖北',
  '湖南',
  '安徽',
  '江西',
  '四川',
  '贵州',
  '内蒙',
  '青海',
  '新疆',
  '西藏',
  '海南',
  // '香港',
  // '澳门',
  // '台湾'
];
const CityOptions = [
  {
    "label": "直辖市",
    "options": ["北京市", "上海市", "天津市", "重庆市", "香港", "澳门"]
  },
  {
    "label": "副省级城市",
    "options": ["大连市", "青岛市", "苏州市", "宁波市", "厦门市", "汕头市", "深圳市", "珠海市"],
  },
  {
    "label": "省会城市",
    "options": [
      "呼和浩特市",
      "哈尔滨市",
      "长春市",
      "沈阳市",
      "济南市",
      "合肥市",
      "南京市",
      "杭州市",
      "福州市",
      "广州市",
      "南宁市",
      "昆明市",
      "海口市",
      "石家庄市",
      "郑州市",
      "太原市",
      "西安市",
      "南昌市",
      "武汉市",
      "长沙市",
      "成都市",
      "贵阳市",
      "银川市",
      "兰州市",
      "西宁市",
      "乌鲁木齐市",
      "拉萨市",
      "台北市"
    ]
  }
]
const MethodOptions = [
  {
    "value": "mean-ranking",
    "label": "一般比较法"
  },
  {
    "value": "num-ratio",
    "label": "位次等效法"
  },
  {
    "value": "linear-diff",
    "label": "线性差值法"
  },
  {
    "value": "batch-diff",
    "label": "批次线差值法"
  },
]
const BatchOptions = [
  // '全部批次',
  '提前批',
  '本科批',
  '高职(专科)批',
  // '地方农村专项',
];
const CollegeLevelOptions = [
  '全部',
  '本科',
  '高职'
];
const CollegeTypeOptions = [
  '全部',
  '综合',
  '理工',
  '农林',
  '医药',
  '师范',
  '语言',
  '财经',
  '政法',
  '体育',
  '艺术',
  '民族',
  '军事',
  '其他'
];
const CollegeSponsorOptions = [
  '全部',
  '公办',
  '民办',
  '合作办学'
];
const CollegeFeatureOptions = [
  '全部',
  '985',
  '211',
  '双一流',
  '部委直属',
  '强基计划',
  '双高计划',
  '国际合作'
];

const CollegeOptions = [
  {
    "label": "985高校",
    "options": [
      "北京大学",
      "清华大学",
      "复旦大学",
      "上海交通大学",
      "浙江大学",
      "南京大学",
      "中国科学技术大学",
      "哈尔滨工业大学",
      "西安交通大学",
      "北京航空航天大学",
      "北京师范大学",
      "中国人民大学",
      "同济大学",
      "南开大学",
      "天津大学",
      "武汉大学",
      "华中科技大学",
      "中山大学",
      "东南大学",
      "四川大学",
      "吉林大学",
      "厦门大学",
      "山东大学",
      "中国海洋大学",
      "大连理工大学",
      "北京理工大学",
      "重庆大学",
      "电子科技大学",
      "湖南大学",
      "中南大学",
      "西北工业大学",
      "兰州大学",
      "东北大学",
      "华南理工大学",
      "华东师范大学",
      "中央民族大学",
      "国防科技大学",
      "西北农林科技大学"      
    ]
  },
  {
    "label": "211高校",
    "options": [
      "北京大学",
      "清华大学",
      "复旦大学",
      "上海交通大学",
      "浙江大学",
      "南京大学",
      "中国科学技术大学",
      "哈尔滨工业大学",
      "西安交通大学",
      "北京航空航天大学",
      "北京师范大学",
      "中国人民大学",
      "同济大学",
      "南开大学",
      "天津大学",
      "武汉大学",
      "华中科技大学",
      "中山大学",
      "东南大学",
      "四川大学",
      "吉林大学",
      "厦门大学",
      "山东大学",
      "中国海洋大学",
      "大连理工大学",
      "北京理工大学",
      "重庆大学",
      "电子科技大学",
      "湖南大学",
      "中南大学",
      "西北工业大学",
      "兰州大学",
      "东北大学",
      "华南理工大学",
      "华东师范大学",
      "中央民族大学",
      "国防科技大学",
      "西北农林科技大学",
      "北京交通大学",
      "北京工业大学",
      "北京科技大学",
      "北京化工大学",
      "北京邮电大学",
      "中国农业大学",
      "北京林业大学",
      "北京中医药大学",
      "北京外国语大学",
      "中国传媒大学",
      "中央财经大学",
      "对外经济贸易大学",
      "北京体育大学",
      "中央音乐学院",
      "中国政法大学",
      "华北电力大学",
      "天津医科大学",
      "河北工业大学",
      "太原理工大学",
      "内蒙古大学",
      "辽宁大学",
      "大连海事大学",
      "延边大学",
      "东北师范大学",
      "哈尔滨工程大学",
      "东北农业大学",
      "东北林业大学",
      "华东理工大学",
      "东华大学",
      "上海外国语大学",
      "上海大学",
      "第二军医大学",
      "苏州大学",
      "南京航空航天大学",
      "南京理工大学",
      "中国矿业大学",
      "河海大学",
      "江南大学",
      "南京农业大学",
      "中国药科大学",
      "南京师范大学",
      "安徽大学",
      "合肥工业大学",
      "福州大学",
      "南昌大学",
      "中国石油大学",
      "郑州大学",
      "武汉理工大学",
      "华中农业大学",
      "华中师范大学",
      "中南财经政法大学",
      "湖南师范大学",
      "暨南大学",
      "华南师范大学",
      "广西大学",
      "海南大学",
      "西南交通大学",
      "四川农业大学",
      "西南财经大学",
      "贵州大学",
      "云南大学",
      "西藏大学",
      "西北大学",
      "西安电子科技大学",
      "长安大学",
      "陕西师范大学",
      "第四军医大学",
      "青海大学",
      "宁夏大学",
      "新疆大学",
      "石河子大学"
    ]    
  }
]
const CollegeDispcilineOptions = 
[
  [
    { 
      "label": "哲学", 
      "disciplines": [
        {
          "code": "0101",
          "name": "哲学类"
        }
      ]
    },
    {
      "label": "经济学",
      "disciplines": [
        {
          "code": "0201",
          "name": "经济学类"
        },
        {
          "code": "0202",
          "name": "财政学类"
        },
        {
          "code": "0203",
          "name": "金融学类"
        },
        {
          "code": "0204",
          "name": "经济与贸易类"
        }
      ]
    },
    {
      "label": "法学",
      "disciplines": [
        {
          "code": "0301",
          "name": "法学类"
        },
        {
          "code": "0302",
          "name": "政治学类"
        },
        {
          "code": "0303",
          "name": "社会学类"
        },
        {
          "code": "0304",
          "name": "民族学类"
        },
        {
          "code": "0305",
          "name": "马克思主义理论类"
        },
        {
          "code": "0306",
          "name": "公安学类"
        }
      ]
    },
    {
      "label": "教育学",
      "disciplines": [
        {
          "code": "0401",
          "name": "教育学类"
        },
        {
          "code": "0402",
          "name": "体育学类"
        }
      ]
    },
    {
      "label": "文学",
      "disciplines": [
        {
          "code": "0501",
          "name": "中国语言文学类"
        },
        {
          "code": "0502",
          "name": "外国语言文学类"
        },
        {
          "code": "0503",
          "name": "新闻传播学类"
        }
      ]
    },
    {
      "label": "历史学",
      "disciplines": [
        {
          "code": "0601",
          "name": "历史学类"
        }
      ]
    },
    {
      "label": "理学",
      "disciplines": [
        {
          "code": "0701",
          "name": "数学类"
        },
        {
          "code": "0702",
          "name": "物理学类"
        },
        {
          "code": "0703",
          "name": "化学类"
        },
        {
          "code": "0704",
          "name": "天文学类"
        },
        {
          "code": "0705",
          "name": "地理科学类"
        },
        {
          "code": "0706",
          "name": "大气科学类"
        },
        {
          "code": "0707",
          "name": "海洋科学类"
        },
        {
          "code": "0708",
          "name": "地球物理学类"
        },
        {
          "code": "0709",
          "name": "地质学类"
        },
        {
          "code": "0710",
          "name": "生物科学类"
        },
        {
          "code": "0711",
          "name": "心理学类"
        },
        {
          "code": "0712",
          "name": "统计学类"
        }
      ]
    },
    {
      "label": "工学",
      "disciplines": [
        {
          "code": "0801",
          "name": "力学类"
        },
        {
          "code": "0802",
          "name": "机械类"
        },
        {
          "code": "0803",
          "name": "仪器类"
        },
        {
          "code": "0804",
          "name": "材料类"
        },
        {
          "code": "0805",
          "name": "能源动力类"
        },
        {
          "code": "0806",
          "name": "电气类"
        },
        {
          "code": "0807",
          "name": "电子信息类"
        },
        {
          "code": "0808",
          "name": "自动化类"
        },
        {
          "code": "0809",
          "name": "计算机类"
        },
        {
          "code": "0810",
          "name": "土木类"
        },
        {
          "code": "0811",
          "name": "水利类"
        },
        {
          "code": "0812",
          "name": "测绘类"
        },
        {
          "code": "0813",
          "name": "化工与制药类"
        },
        {
          "code": "0814",
          "name": "地质类"
        },
        {
          "code": "0815",
          "name": "矿业类"
        },
        {
          "code": "0816",
          "name": "纺织类"
        },
        {
          "code": "0817",
          "name": "轻工类"
        },
        {
          "code": "0818",
          "name": "交通运输类"
        },
        {
          "code": "0819",
          "name": "海洋工程类"
        },
        {
          "code": "0820",
          "name": "航空航天类"
        },
        {
          "code": "0821",
          "name": "兵器类"
        },
        {
          "code": "0822",
          "name": "核工程类"
        },
        {
          "code": "0823",
          "name": "农业工程类"
        },
        {
          "code": "0824",
          "name": "林业工程类"
        },
        {
          "code": "0825",
          "name": "环境科学与工程类"
        },
        {
          "code": "0826",
          "name": "生物医学工程类"
        },
        {
          "code": "0827",
          "name": "食品科学与工程类"
        },
        {
          "code": "0828",
          "name": "建筑类"
        },
        {
          "code": "0829",
          "name": "安全科学与工程类"
        },
        {
          "code": "0830",
          "name": "生物工程类"
        },
        {
          "code": "0831",
          "name": "公安技术类"
        },
        {
          "code": "0832",
          "name": "交叉工程类"
        }
      ]
    },
    {
      "label": "农学",
      "disciplines": [
        {
          "code": "0901",
          "name": "植物生产类"
        },
        {
          "code": "0902",
          "name": "自然保护与环境生态类"
        },
        {
          "code": "0903",
          "name": "动物生产类"
        },
        {
          "code": "0904",
          "name": "动物医学类"
        },
        {
          "code": "0905",
          "name": "林学类"
        },
        {
          "code": "0906",
          "name": "水产类"
        },
        {
          "code": "0907",
          "name": "草学类"
        }
      ]
    },
    {
      "label": "医学",
      "disciplines": [
        {
          "code": "1001",
          "name": "基础医学类"
        },
        {
          "code": "1002",
          "name": "临床医学类"
        },
        {
          "code": "1003",
          "name": "口腔医学类"
        },
        {
          "code": "1004",
          "name": "公共卫生与预防医学类"
        },
        {
          "code": "1005",
          "name": "中医学类"
        },
        {
          "code": "1006",
          "name": "中西医结合类"
        },
        {
          "code": "1007",
          "name": "药学类"
        },
        {
          "code": "1008",
          "name": "中药学类"
        },
        {
          "code": "1009",
          "name": "法医学类"
        },
        {
          "code": "1010",
          "name": "医学技术类"
        },
        {
        "code": "1011",
        "name": "护理学类"
        }
      ]
    },
    {
      "label": "管理学",
      "disciplines": [
      {
      "code": "1201",
      "name": "管理科学与工程类"
      },
      {
      "code": "1202",
      "name": "工商管理类"
      },
      {
      "code": "1203",
      "name": "农业经济管理类"
      },
      {
      "code": "1204",
      "name": "公共管理类"
      },
      {
      "code": "1205",
      "name": "图书情报与档案管理类"
      },
      {
      "code": "1206",
      "name": "物流管理与工程类"
      },
      {
      "code": "1207",
      "name": "工业工程类"
      },
      {
      "code": "1208",
      "name": "电子商务类"
      },
      {
      "code": "1209",
      "name": "旅游管理类"
      }
      ]
    },
    {
      "label": "艺术学",
      "disciplines": [
        {
          "code": "1301",
          "name": "艺术学理论类"
        },
        {
          "code": "1302",
          "name": "音乐与舞蹈学类"
        },
        {
          "code": "1303",
          "name": "戏剧与影视学类"
        },
        {
          "code": "1304",
          "name": "美术学类"
        },
        {
          "code": "1305",
          "name": "设计学类"
        }
      ]
    }
  ],
  [
    { 
      "label": "农林牧渔", 
      "disciplines": [
        {
          "code": "2101",
          "name": "农业类"
        },
        {
          "code": "2102",
          "name": "林业类"
        },
        {
          "code": "2103",
          "name": "畜牧业类"
        },
        {
          "code": "2104",
          "name": "渔业类"
        },
      ]
    },
    {
      "label": "资源环境与安全",
      "disciplines": [
        {
          "code": "2201",
          "name": "资源勘查类"
        },
        {
          "code": "2202",
          "name": "地质类"
        },
        {
          "code": "2203",
          "name": "测绘地理信息类"
        },
        {
          "code": "2204",
          "name": "石油与天然气类"
        },
        {
          "code": "2205",
          "name": "煤炭类"
        },
        {
          "code": "2207",
          "name": "气象类"
        },
        {
          "code": "2208",
          "name": "环境保护类"
        },
        {
          "code": "2209",
          "name": "安全类"
        }
      ]
    },
    {
      "label": "能源动力与材料",
      "disciplines": [
        {
          "code": "2301",
          "name": "电力技术类"
        },
        {
          "code": "2302",
          "name": "热能与发电工程类"
        },
        {
          "code": "2303",
          "name": "新能源发电工程类"
        },
        {
          "code": "2304",
          "name": "黑色金属材料类"
        },
        {
          "code": "2305",
          "name": "有色金属材料类"
        },
        {
          "code": "2306",
          "name": "非金属材料类"
        },
        {
          "code": "2307",
          "name": "建筑材料类"
        }
      ]
    },
    {
      "label": "土木建筑",
      "disciplines": [
        {
          "code": "2401",
          "name": "建筑设计类"
        },
        {
          "code": "2402",
          "name": "城乡规划与管理类"
        },
        {
          "code": "2403",
          "name": "土建施工类"
        },
        {
          "code": "2404",
          "name": "建筑设备类"
        },
        {
          "code": "2405",
          "name": "建设工程管理类"
        },
        {
          "code": "2406",
          "name": "市政工程类"
        },
        {
          "code": "2407",
          "name": "房地产类"
        }
      ]
    },
    {
      "label": "水利",
      "disciplines": [
        {
          "code": "2501",
          "name": "水文水资源类"
        },
        {
          "code": "2502",
          "name": "水利工程与管理类"
        },
        {
          "code": "2503",
          "name": "水利水电设备类"
        },
        {
          "code": "2504",
          "name": "水土保持与水环境类"
        }
      ]
    },
    {
      "label": "装备制造",
      "disciplines": [
        {
          "code": "2601",
          "name": "机械设计制造类"
        },
        {
          "code": "2602",
          "name": "机电设备类"
        },
        {
          "code": "2603",
          "name": "自动化类"
        },
        {
          "code": "2604",
          "name": "轨道装备类"
        },
        {
          "code": "2605",
          "name": "船舶与海洋工程装备类"
        },
        {
          "code": "2606",
          "name": "航空装备类"
        },
        {
          "code": "2607",
          "name": "汽车制造类"
        },
      ]
    },
    {
      "label": "生物与化工",
      "disciplines": [
        {
          "code": "2701",
          "name": "生物技术类"
        },
        {
          "code": "2702",
          "name": "化工技术类"
        }
      ]
    },
    {
      "label": "轻工纺织",
      "disciplines": [
        {
          "code": "2801",
          "name": "轻化工类"
        },
        {
          "code": "2802",
          "name": "包装类"
        },
        {
          "code": "2803",
          "name": "印刷类"
        },
        {
          "code": "2804",
          "name": "纺织服装类"
        }
      ]
    },
    {
      "label": "食品药品与粮食",
      "disciplines": [
        {
          "code": "2901",
          "name": "食品类"
        },
        {
          "code": "2902",
          "name": "药品与医疗器械类"
        },
        {
          "code": "2903",
          "name": "粮食类"
        }
      ]
    },
    {
      "label": "交通运输",
      "disciplines": [
        {
          "code": "3001",
          "name": "铁道运输类"
        },
        {
          "code": "3002",
          "name": "道路运输类"
        },
        {
          "code": "3003",
          "name": "水上运输类"
        },
        {
          "code": "3004",
          "name": "航空运输类"
        },
        {
          "code": "3006",
          "name": "城市轨道交通类"
        },
        {
          "code": "3007",
          "name": "邮政类"
        }
      ]
    },
    {
      "label": "电子与信息",
      "disciplines": [
        {
        "code": "3101",
        "name": "电子信息类"
        },
        {
        "code": "3102",
        "name": "计算机类"
        },
        {
        "code": "3103",
        "name": "通信类"
        },
        {
        "code": "3104",
        "name": "集成电路类"
        }
      ]
    },
    {
      "label": "医药卫生",
      "disciplines": [
        {
          "code": "3202",
          "name": "护理类"
        },
        {
          "code": "3203",
          "name": "药学类"
        },
        {
          "code": "3204",
          "name": "中医药类"
        },
        {
          "code": "3205",
          "name": "医学技术类"
        },
        {
          "code": "3206",
          "name": "康复治疗类"
        },
        {
          "code": "3207",
          "name": "公共卫生与卫生管理类"
        },
        {
          "code": "3208",
          "name": "健康管理与促进类"
        },
        {
          "code": "3209",
          "name": "眼视光类"
        },
      ]
    },
    {
      "label": "财经商贸",
      "disciplines": [
        {
          "code": "3301",
          "name": "财政税务类"
        },
        {
          "code": "3302",
          "name": "金融类"
        },
        {
          "code": "3303",
          "name": "财务会计类"
        },
        {
          "code": "3304",
          "name": "统计类"
        },
        {
          "code": "3305",
          "name": "经济贸易类"
        },
        {
          "code": "3306",
          "name": "工商管理类"
        },
        {
          "code": "3307",
          "name": "电子商务类"
        },
        {
          "code": "3308",
          "name": "物流类"
        },
      ]
    },
    {
      "label": "旅游",
      "disciplines": [
        {
          "code": "3401",
          "name": "旅游类"
        },
        {
          "code": "3402",
          "name": "餐饮类"
        },
      ]
    },
    {
      "label": "文化艺术",
      "disciplines": [
        {
          "code": "3501",
          "name": "艺术设计类"
        },
        {
          "code": "3502",
          "name": "表演艺术类"
        },
        {
          "code": "3504",
          "name": "文化服务类"
        }
      ]
    },
    {
      "label": "新闻传播",
      "disciplines": [
        {
          "code": "3601",
          "name": "新闻出版类"
        },
        {
          "code": "3602",
          "name": "广播影视类"
        },
      ]
    },
    {
      "label": "教育与体育",
      "disciplines": [
        {
          "code": "3701",
          "name": "教育类"
        },
        {
          "code": "3702",
          "name": "语言类"
        },
        {
          "code": "3703",
          "name": "体育类"
        },
      ]
    },
    {
      "label": "公安与司法",
      "disciplines": [
        {
          "code": "3802",
          "name": "公安技术类"
        },
        {
          "code": "3803",
          "name": "侦查类"
        },
        {
          "code": "3804",
          "name": "法律实务类"
        },
        {
          "code": "3805",
          "name": "法律执行类"
        },
        {
          "code": "3806",
          "name": "司法技术类"
        },
        {
          "code": "3807",
          "name": "安全防范类"
        }        
      ]
    },
    {
      "label": "公共管理与服务",
      "disciplines": [
        {
          "code": "3901",
          "name": "公共事业类"
        },
        {
          "code": "3902",
          "name": "公共管理类"
        },
        {
          "code": "3903",
          "name": "公共服务类"
        },
      ]
    }
  ],
  [
    { 
      "label": "农林牧渔", 
      "disciplines": [
        {
          "code": "4101",
          "name": "农业类"
        },
        {
          "code": "4102",
          "name": "林业类"
        },
        {
          "code": "4103",
          "name": "畜牧业类"
        },
        {
          "code": "4104",
          "name": "渔业类"
        },
      ]
    },
    {
      "label": "资源环境与安全",
      "disciplines": [
        {
          "code": "4201",
          "name": "资源勘查类"
        },
        {
          "code": "4202",
          "name": "地质类"
        },
        {
          "code": "4203",
          "name": "测绘地理信息类"
        },
        {
          "code": "4204",
          "name": "石油与天然气类"
        },
        {
          "code": "4205",
          "name": "煤炭类"
        },
        {
          "code": "4206",
          "name": "金属与非金属矿类"
        },        
        {
          "code": "4207",
          "name": "气象类"
        },
        {
          "code": "4208",
          "name": "环境保护类"
        },
        {
          "code": "4209",
          "name": "安全类"
        }
      ]
    },
    {
      "label": "能源动力与材料",
      "disciplines": [
        {
          "code": "4301",
          "name": "电力技术类"
        },
        {
          "code": "4302",
          "name": "热能与发电工程类"
        },
        {
          "code": "4303",
          "name": "新能源发电工程类"
        },
        {
          "code": "4304",
          "name": "黑色金属材料类"
        },
        {
          "code": "4305",
          "name": "有色金属材料类"
        },
        {
          "code": "4306",
          "name": "非金属材料类"
        },
        {
          "code": "4307",
          "name": "建筑材料类"
        }
      ]
    },
    {
      "label": "土木建筑",
      "disciplines": [
        {
          "code": "4401",
          "name": "建筑设计类"
        },
        {
          "code": "4402",
          "name": "城乡规划与管理类"
        },
        {
          "code": "4403",
          "name": "土建施工类"
        },
        {
          "code": "4404",
          "name": "建筑设备类"
        },
        {
          "code": "4405",
          "name": "建设工程管理类"
        },
        {
          "code": "4406",
          "name": "市政工程类"
        },
        {
          "code": "4407",
          "name": "房地产类"
        }
      ]
    },
    {
      "label": "水利",
      "disciplines": [
        {
          "code": "4501",
          "name": "水文水资源类"
        },
        {
          "code": "4502",
          "name": "水利工程与管理类"
        },
        {
          "code": "4503",
          "name": "水利水电设备类"
        },
        {
          "code": "4504",
          "name": "水土保持与水环境类"
        }
      ]
    },
    {
      "label": "装备制造",
      "disciplines": [
        {
          "code": "4601",
          "name": "机械设计制造类"
        },
        {
          "code": "4602",
          "name": "机电设备类"
        },
        {
          "code": "4603",
          "name": "自动化类"
        },
        {
          "code": "4604",
          "name": "轨道装备类"
        },
        {
          "code": "4605",
          "name": "船舶与海洋工程装备类"
        },
        {
          "code": "4606",
          "name": "航空装备类"
        },
        {
          "code": "4607",
          "name": "汽车制造类"
        },
      ]
    },
    {
      "label": "生物与化工",
      "disciplines": [
        {
          "code": "4701",
          "name": "生物技术类"
        },
        {
          "code": "4702",
          "name": "化工技术类"
        }
      ]
    },
    {
      "label": "轻工纺织",
      "disciplines": [
        {
          "code": "4801",
          "name": "轻化工类"
        },
        {
          "code": "4802",
          "name": "包装类"
        },
        {
          "code": "4803",
          "name": "印刷类"
        },
        {
          "code": "4804",
          "name": "纺织服装类"
        }
      ]
    },
    {
      "label": "食品药品与粮食",
      "disciplines": [
        {
          "code": "4901",
          "name": "食品类"
        },
        {
          "code": "4902",
          "name": "药品与医疗器械类"
        },
        {
          "code": "4903",
          "name": "粮食类"
        }
      ]
    },
    {
      "label": "交通运输",
      "disciplines": [
        {
          "code": "5001",
          "name": "铁道运输类"
        },
        {
          "code": "5002",
          "name": "道路运输类"
        },
        {
          "code": "5003",
          "name": "水上运输类"
        },
        {
          "code": "5004",
          "name": "航空运输类"
        },
        {
          "code": "5006",
          "name": "城市轨道交通类"
        },
        {
          "code": "5007",
          "name": "邮政类"
        }
      ]
    },
    {
      "label": "电子与信息",
      "disciplines": [
        {
        "code": "5101",
        "name": "电子信息类"
        },
        {
        "code": "5102",
        "name": "计算机类"
        },
        {
        "code": "5103",
        "name": "通信类"
        },
        {
        "code": "5104",
        "name": "集成电路类"
        }
      ]
    },
    {
      "label": "医药卫生",
      "disciplines": [
        {
          "code": "5201",
          "name": "临床医学类"
        },
        {
          "code": "5202",
          "name": "护理类"
        },
        {
          "code": "5203",
          "name": "药学类"
        },
        {
          "code": "5204",
          "name": "中医药类"
        },
        {
          "code": "5205",
          "name": "医学技术类"
        },
        {
          "code": "5206",
          "name": "康复治疗类"
        },
        {
          "code": "5207",
          "name": "公共卫生与卫生管理类"
        },
        {
          "code": "5208",
          "name": "健康管理与促进类"
        },
        {
          "code": "5209",
          "name": "眼视光类"
        },
      ]
    },
    {
      "label": "财经商贸",
      "disciplines": [
        {
          "code": "5301",
          "name": "财政税务类"
        },
        {
          "code": "5302",
          "name": "金融类"
        },
        {
          "code": "5303",
          "name": "财务会计类"
        },
        {
          "code": "5304",
          "name": "统计类"
        },
        {
          "code": "5305",
          "name": "经济贸易类"
        },
        {
          "code": "5306",
          "name": "工商管理类"
        },
        {
          "code": "5307",
          "name": "电子商务类"
        },
        {
          "code": "5308",
          "name": "物流类"
        },
      ]
    },
    {
      "label": "旅游",
      "disciplines": [
        {
          "code": "5401",
          "name": "旅游类"
        },
        {
          "code": "5402",
          "name": "餐饮类"
        },
      ]
    },
    {
      "label": "文化艺术",
      "disciplines": [
        {
          "code": "5501",
          "name": "艺术设计类"
        },
        {
          "code": "5502",
          "name": "表演艺术类"
        },
        {
          "code": "5503",
          "name": "民族文化艺术类"
        },        
        {
          "code": "5504",
          "name": "文化服务类"
        },
      ]
    },
    {
      "label": "新闻传播",
      "disciplines": [
        {
          "code": "5601",
          "name": "新闻出版类"
        },
        {
          "code": "5602",
          "name": "广播影视类"
        },
      ]
    },
    {
      "label": "教育与体育",
      "disciplines": [
        {
          "code": "5701",
          "name": "教育类"
        },
        {
          "code": "5702",
          "name": "语言类"
        },
        {
          "code": "5703",
          "name": "体育类"
        },
      ]
    },
    {
      "label": "公安与司法",
      "disciplines": [
        {
          "code": "5801",
          "name": "公安管理类"
        },
        {
          "code": "5802",
          "name": "公安技术类"
        },        
        {
          "code": "5803",
          "name": "侦查类"
        },
        {
          "code": "5804",
          "name": "法律实务类"
        },
        {
          "code": "5805",
          "name": "法律执行类"
        },
        {
          "code": "5806",
          "name": "司法技术类"
        },
        {
          "code": "5807",
          "name": "安全防范类"
        }        
      ]
    },
    {
      "label": "公共管理与服务",
      "disciplines": [
        {
          "code": "5901",
          "name": "公共事业类"
        },
        {
          "code": "5902",
          "name": "公共管理类"
        },
        {
          "code": "5903",
          "name": "公共服务类"
        },
        {
          "code": "5904",
          "name": "文秘类"
        },
      ]
    }
  ],
]
const GroupOptions = [
//  '全部分组',
  '物理组',
  '历史组',
];
const CourseOptions = [
  {
    "label": "999不限选考科目",
    "value": "999",
  },
  {
    "label": "900选考地理",
    "value": "900",
  },
  // {
  //   "label": "800首考历史",
  //   "value": "800",
  // },
  {
    "label": "719选考政治+地理",
    "value": "719",
  },
  {
    "label": "709选考政治|地理",
    "value": "709",
  },
  {
    "label": "700选考政治",
    "value": "700",
  },
  {
    "label": "619选考生物+地理",
    "value": "619",
  },
  {
    "label": "609选考生物|地理",
    "value": "609",
  },
  {
    "label": "617选考生物+政治",
    "value": "617",
  },
  {
    "label": "607选考生物|政治",
    "value": "607",
  },
  {
    "label": "600选考生物",
    "value": "600",
  },
  {
    "label": "519选考化学+地理",
    "value": "519",
  },
  {
    "label": "509选考化学|地理",
    "value": "509",
  },
  {
    "label": "517选考化学+政治",
    "value": "517",
  },
  {
    "label": "507选考化学|政治",
    "value": "507",
  },
  {
    "label": "516选考化学+生物",
    "value": "516",
  },
  {
    "label": "506选考化学|生物",
    "value": "506",
  },
  {
    "label": "500选考化学",
    "value": "500",
  },
  // {
  //   "label": "400首考物理",
  //   "value": "400",
  // },
  // {
  //   "label": "300必考英语",
  //   "value": "300",
  // },
  // {
  //   "label": "200必考数学",
  //   "value": "200",
  // },
  // {
  //   "label": "100必考语文",
  //   "value": "100",
  // },  
]
const CareerOptions = [
  {
    "code": "1",
    "name": "国家机关、党群组织、企业、事业单位负责人",
    "medium_classes": [
      {"code": "1-1", "name": "中国共产党机关负责人"},
      {"code": "1-2", "name": "国家机关负责人"},
      {"code": "1-3", "name": "民主党派和工商联负责人"},
      {"code": "1-4", "name": "人民团体和群众团体负责人"},
      {"code": "1-5", "name": "企事业单位负责人"}
    ]
  },
  {
    "code": "2",
    "name": "专业技术人员",
    "medium_classes": [
      {"code": "2-1", "name": "科学研究人员"},
      {"code": "2-2", "name": "工程技术人员"},
      {"code": "2-3", "name": "农业技术人员"},
      {"code": "2-4", "name": "飞机和船舶技术人员"},
      {"code": "2-5", "name": "卫生专业技术人员"},
      {"code": "2-6", "name": "经济和金融专业人员"},
      {"code": "2-7", "name": "法律、社会和宗教专业人员"},
      {"code": "2-8", "name": "教学人员"},
      {"code": "2-9", "name": "文学艺术、体育专业人员"},
      {"code": "2-10", "name": "新闻出版、文化专业人员"},
      {"code": "2-11", "name": "其他专业技术人员"}
    ]
  },
  {
    "code": "3",
    "name": "办事人员和有关人员",
    "medium_classes": [
      {"code": "3-1", "name": "行政办公人员"},
      {"code": "3-2", "name": "安全保卫和消防人员"},
      {"code": "3-3", "name": "邮政和电信业务人员"},
      {"code": "3-4", "name": "其他办事人员和有关人员"}
    ]
  },
  {
    "code": "4",
    "name": "社会生产服务和生活服务人员",
    "medium_classes": [
      {"code": "4-1", "name": "批发与零售服务人员"},
      {"code": "4-2", "name": "交通运输、仓储和邮政业服务人员"},
      {"code": "4-3", "name": "住宿和餐饮服务人员"},
      {"code": "4-4", "name": "信息传输、软件和信息技术服务人员"},
      {"code": "4-5", "name": "金融服务人员"},
      {"code": "4-6", "name": "房地产服务人员"},
      {"code": "4-7", "name": "租赁和商务服务人员"},
      {"code": "4-8", "name": "技术服务和维修人员"},
      {"code": "4-9", "name": "水利、环境和公共设施管理服务人员"},
      {"code": "4-10", "name": "居民服务人员"},
      {"code": "4-11", "name": "电力、燃气及水供应服务人员"},
      {"code": "4-12", "name": "修理及制作服务人员"},
      {"code": "4-13", "name": "文化、体育和娱乐服务人员"},
      {"code": "4-14", "name": "健康服务人员"},
      {"code": "4-15", "name": "其他社会生产和生活服务人员"}
    ]
  },
  {
    "code": "5",
    "name": "农、林、牧、渔业生产及辅助人员",
    "medium_classes": [
      {"code": "5-1", "name": "农业生产人员"},
      {"code": "5-2", "name": "林业生产人员"},
      {"code": "5-3", "name": "畜牧业生产人员"},
      {"code": "5-4", "name": "渔业生产人员"},
      {"code": "5-5", "name": "水利设施管理养护人员"},
      {"code": "5-6", "name": "农、林、牧、渔业生产辅助人员"}
    ]
  },
  {
    "code": "6",
    "name": "生产制造及有关人员",
    "medium_classes": [
      {"code": "6-1", "name": "农副产品加工人员"},
      {"code": "6-2", "name": "食品、饮料生产加工人员"},
      {"code": "6-3", "name": "烟草及其制品加工人员"},
      {"code": "6-4", "name": "纺织、针织、印染人员"},
      {"code": "6-5", "name": "纺织品、服装和皮革、毛皮制品加工制作人员"},
      {"code": "6-6", "name": "木材加工、家具与木制品制作人员"},
      {"code": "6-7", "name": "造纸及纸制品生产加工人员"},
      {"code": "6-8", "name": "印刷和记录媒介复制人员"},
      {"code": "6-9", "name": "文教、工美、体育和娱乐用品制作人员"},
      {"code": "6-10", "name": "石油加工和炼焦、煤化工生产人员"},
      {"code": "6-11", "name": "化学原料和化学制品制造人员"},
      {"code": "6-12", "name": "医药制造人员"},
      {"code": "6-13", "name": "化学纤维制造人员"},
      {"code": "6-14", "name": "橡胶和塑料制品制造人员"},
      {"code": "6-15", "name": "非金属矿物制品制造人员"},
      {"code": "6-16", "name": "采矿人员"},
      {"code": "6-17", "name": "金属冶炼和压延加工人员"},
      {"code": "6-18", "name": "机械制造基础加工人员"},
      {"code": "6-19", "name": "金属制品制造人员"},
      {"code": "6-20", "name": "通用设备制造人员"},
      {"code": "6-21", "name": "专用设备制造人员"},
      {"code": "6-22", "name": "汽车制造人员"},
      {"code": "6-23", "name": "铁路、船舶、航空设备制造人员"},
      {"code": "6-24", "name": "电气机械和器材制造人员"},
      {"code": "6-25", "name": "计算机、通信和其他电子设备制造人员"},
      {"code": "6-26", "name": "仪器仪表制造人员"},
      {"code": "6-27", "name": "废弃资源综合利用人员"},
      {"code": "6-28", "name": "电力、热力、气体、水生产和输配人员"},
      {"code": "6-29", "name": "建筑施工人员"},
      {"code": "6-30", "name": "运输设备和通用工程机械操作人员及有关人员"},
      {"code": "6-31", "name": "生产辅助人员"}
    ]
  },
  {
    "code": "7",
    "name": "军人",
    "medium_classes": [
      {"code": "7-1", "name": "军人"}
    ]
  },
  {
    "code": "8",
    "name": "不便分类的其他从业人员",
    "medium_classes": [
      {"code": "8-1", "name": "不便分类的其他从业人员"}
    ]
  }
]
const IndustryOptions =[
    {
      "code": "A",
      "name": "农、林、牧、渔业",
      "subcategories": [
        {"code": "01", "name": "农业"},
        {"code": "02", "name": "林业"},
        {"code": "03", "name": "畜牧业"},
        {"code": "04", "name": "渔业"},
        {"code": "05", "name": "农、林、牧、渔专业及辅助性活动"}
      ]
    },
    {
      "code": "B",
      "name": "采矿业",
      "subcategories": [
        {"code": "06", "name": "煤炭开采和洗选业"},
        {"code": "07", "name": "石油和天然气开采业"},
        {"code": "08", "name": "黑色金属矿采选业"},
        {"code": "09", "name": "有色金属矿采选业"},
        {"code": "10", "name": "非金属矿采选业"}
      ]
    },
    {
      "code": "C",
      "name": "制造业",
      "subcategories": [
        {"code": "13", "name": "农副食品加工业"},
        {"code": "14", "name": "食品制造业"},
        {"code": "15", "name": "酒、饮料和精制茶制造业"},
        {"code": "25", "name": "石油、煤炭及其他燃料加工业"},
        {"code": "36", "name": "汽车制造业"}
      ]
    },
    {
      "code": "D",
      "name": "电力、热力、燃气及水生产和供应业",
      "subcategories": [
        {"code": "44", "name": "电力、热力生产和供应业"},
        {"code": "45", "name": "燃气生产和供应业"},
        {"code": "46", "name": "水的生产和供应业"}
      ]
    },
    {
      "code": "E",
      "name": "建筑业",
      "subcategories": [
        {"code": "47", "name": "房屋建筑业"},
        {"code": "48", "name": "土木工程建筑业"},
        {"code": "49", "name": "建筑安装业"}
      ]
    },
    {
      "code": "F",
      "name": "批发和零售业",
      "subcategories": [
        {"code": "51", "name": "批发业"},
        {"code": "52", "name": "零售业"}
      ]
    },
    {
      "code": "G",
      "name": "交通运输、仓储和邮政业",
      "subcategories": [
        {"code": "53", "name": "铁路运输业"},
        {"code": "54", "name": "道路运输业"},
        {"code": "55", "name": "水上运输业"}
      ]
    },
    {
      "code": "H",
      "name": "住宿和餐饮业",
      "subcategories": [
        {"code": "61", "name": "住宿业"},
        {"code": "62", "name": "餐饮业"}
      ]
    },
    {
      "code": "I",
      "name": "信息传输、软件和信息技术服务业",
      "subcategories": [
        {"code": "63", "name": "电信、广播电视和卫星传输服务"},
        {"code": "64", "name": "互联网和相关服务"},
        {"code": "65", "name": "软件和信息技术服务业"}
      ]
    },
    {
      "code": "J",
      "name": "金融业",
      "subcategories": [
        {"code": "66", "name": "货币金融服务"},
        {"code": "67", "name": "资本市场服务"},
        {"code": "68", "name": "保险业"}
      ]
    },
    {
      "code": "K",
      "name": "房地产业",
      "subcategories": [
        {"code": "70", "name": "房地产业"}
      ]
    },
    {
      "code": "L",
      "name": "租赁和商务服务业",
      "subcategories": [
        {"code": "71", "name": "租赁业"},
        {"code": "72", "name": "商务服务业"}
      ]
    },
    {
      "code": "M",
      "name": "科学研究和技术服务业",
      "subcategories": [
        {"code": "73", "name": "研究和试验发展"},
        {"code": "74", "name": "专业技术服务业"}
      ]
    },
    {
      "code": "N",
      "name": "水利、环境和公共设施管理业",
      "subcategories": [
        {"code": "76", "name": "水利管理业"},
        {"code": "77", "name": "生态保护和环境治理业"}
      ]
    },
    {
      "code": "O",
      "name": "居民服务、修理和其他服务业",
      "subcategories": [
        {"code": "80", "name": "居民服务业"},
        {"code": "81", "name": "机动车、电子产品和日用产品修理业"}
      ]
    },
    {
      "code": "P",
      "name": "教育",
      "subcategories": [
        {"code": "83", "name": "教育"}
      ]
    },
    {
      "code": "Q",
      "name": "卫生和社会工作",
      "subcategories": [
        {"code": "84", "name": "卫生"},
        {"code": "85", "name": "社会工作"}
      ]
    },
    {
      "code": "R",
      "name": "文化、体育和娱乐业",
      "subcategories": [
        {"code": "86", "name": "新闻和出版业"},
        {"code": "87", "name": "广播、电视、电影和录音制作业"}
      ]
    },
    {
      "code": "S",
      "name": "公共管理、社会保障和社会组织",
      "subcategories": [
        {"code": "91", "name": "国家机构"},
        {"code": "92", "name": "人民政协、民主党派"}
      ]
    },
    {
      "code": "T",
      "name": "国际组织",
      "subcategories": [
        {"code": "97", "name": "国际组织"}
      ]
    }
]

export const Consts = {
  Uid,
  Token,
  Secret,
  Host,
  Port,
  PDFUrl,
  WebUrl,
  NewsUrl,
  AgentUrl,
  ImageUrl,
  DiagramUrl,
  PageSize,
  IosApp,
  AndroidApp,
  YearOptions,
  ProvinceOptions,
  ProvinceOptionsLess,
  CityOptions,
  MethodOptions,  
  BatchOptions,
  CollegeLevelOptions,
  CollegeTypeOptions,
  CollegeSponsorOptions,
  CollegeFeatureOptions,
  CollegeDispcilineOptions,
  CollegeOptions,  
  GroupOptions,
  CourseOptions,
  CareerOptions,
  IndustryOptions,
} 


/*
const ProvinceOptions = [
  {
    value: 'nation',
    label: '全国',
  },
  {
    value: 'beijing',
    label: '北京',
  },
  {
    value: 'tianjin',
    label: '天津',
  },
  {
    value: 'shanghai',
    label: '上海',
  },
  {
    value: 'chongqing',
    label: '重庆',
  },
  {
    value: 'heilongjiang',
    label: '黑龙江'
  },
  {
    value: 'jilin',
    label: '吉林'
  },
  {
    value: 'liaoning',
    label: '辽宁'
  },
  {
    value: 'shanxi',
    label: '山西'
  },  
  {
    value: 'shandong',
    label: '山东'
  },
  {
    value: 'jiangsu',
    label: '江苏'
  },
  {
    value: 'zhejiang',
    label: '浙江'
  },
  {
    value: 'fujian',
    label: '福建'
  },
  {
    value: 'guangdong',
    label: '广东'
  },
  {
    value: 'guangxi',
    label: '广西'
  },
  {
    value: 'yunnan',
    label: '云南'
  },
  {
    value: 'hebei',
    label: '河北'
  },
  {
    value: 'henan',
    label: '河南'
  },
  {
    value: 'gansu',
    label: '陕西'
  }, 
  {
    value: 'gansu',
    label: '甘肃'
  },
  {
    value: 'ningxia',
    label: '宁夏'
  },   
  {
    value: 'hubei',
    label: '湖北'
  },
  {
    value: 'hunan',
    label: '湖南'
  },    
  {
    value: 'anhui',
    label: '安徽'
  },
  {
    value: 'jiangxi',
    label: '江西'
  },
  {
    value: 'sichuan',
    label: '四川'
  },
  {
    value: 'guizhou',
    label: '贵州'
  },
  {
    value: 'neimeng',
    label: '内蒙'
  },
  {
    value: 'qinghai',
    label: '青海'
  },
  {
    value: 'xinjiang',
    label: '新疆'
  },
  {
    value: 'xizang',
    label: '西藏'
  },
  {
    value: 'hainan',
    label: '海南'
  },
  {
    value: 'xianggang',
    label: '香港'
  },
  {
    value: 'aomen',
    label: '澳门'
  },
  {
    value: 'taiwan',
    label: '台湾'
  }
];
const CollegeLevelOptions = [
  {
    value: 'all',
    label: '全部',
  },
  {
    value: 'college',
    label: '本科',
  },
  {
    value: 'academy',
    label: '专科（职高）',
  }
];
const CollegeTypeOptions = [
  {
    value: 'all',
    label: '全部',
  },
  {
    value: 'complex',
    label: '综合',
  },
  {
    value: 'science&engineering',
    label: '理工',
  },
  {
    value: 'agriculture&forestry',
    label: '农林',
  },
  {
    value: 'medicine',
    label: '医药',
  },
  {
    value: 'normal',
    label: '师范',
  },
  {
    value: 'language',
    label: '语言',
  },
  {
    value: 'finance&economic',
    label: '财经',
  },
  {
    value: 'politic&law',
    label: '政法',
  },
  {
    value: 'athletics',
    label: '体育',
  },
  {
    value: 'artistic',
    label: '艺术',
  },
  {
    value: 'ethnic',
    label: '民族',
  },
  {
    value: 'military',
    label: '军事',
  },
  {
    value: 'other',
    label: '其他',
  }
];
const CollegeSponsorOptions = [
  {
    value: 'all',
    label: '全部',
  },
  {
    value: 'public',
    label: '公办',
  },
  {
    value: 'private',
    label: '民办',
  },
  {
    value: 'cooperative',
    label: '中外合办',
  }
];
const CollegeFeatureOptions = [
  {
    value: 'all',
    label: '全部',
  },
  {
    value: '38',
    label: '985',
  },
  {
    value: '100',
    label: '211',
  },
  {
    value: 'double first-class',
    label: '双一流',
  },
  {
    value: 'directly affiliated with the Ministry of Nation',
    label: '部委直属',
  },
  {
    value: 'strengthening foundation-plan',
    label: '强基计划',
  },
  {
    value: 'high-level vocational colleges and majors',
    label: '双高计划',
  },   
  {
    value: 'international cooperation',
    label: '国际合作',
  }
];
*/